import { Model } from '@vuex-orm/core';
import Folder from '@app2/models/Folder';
import Playlist from '@app2/models/Playlist';

export default class FolderPlaylist extends Model {
  static entity = 'App\\FolderPlaylist';

  static primaryKey = ['folder_id', 'playlist_id'];

  static apiConfig = {
    baseURL: '/api/playlists/',
    actions: {
      storeFolder(playlist, folders, config = {}) {
        return this.post(`${playlist.hash}/folders`, { folders }, config)
      },
      attachFolder(playlist, folders, config = {}) {
        return this.post(`${playlist.hash}/folders/attach`, { folders }, config)
      },
      detachFolder(playlist, folders, config = {}) {
        return this.delete(`${playlist.hash}/folders`, { data: {folders}, ...config })
          .then(() => {
            if (config.save && config.save === false) return;
            folders.forEach(f =>
              FolderPlaylist.delete(r => r.folder_id === f && r.playlist_id === playlist.id)
            );
          },
        );
      }
    }
  };

  static fields() {
    return {
      folder_id: this.attr(null),
      folder: this.belongsTo(Folder, 'folder_id'),
      playlist_id: this.attr(null),
      playlist: this.belongsTo(Playlist, 'playlist_id'),
      position: this.attr(null),
    };
  }
}
